export default __webpack_public_path__ + "static/media/iconUpload.11595cb2.svg";